import React from 'react';
import './Loader.css';

const PostLoader = () => {
    return (
        <div className="post-loader-wrapper">
            <div className="lds-roller">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
            </div>
        </div>
    );
};

export default React.memo(PostLoader);
